<template>
  <div>
    Du erhältst in kürze eine SMS mit einer mobilen TAN an die Nummer {{ mtansend }}. Gib diese bitte in dem untenstehenden Feld ein.
    <base-input
      placeholder="mTAN"
      id="mtan"
      :value="value"
      @input="$emit('input', $event)"
      type="text"
    ></base-input>
  </div>
</template>

<script>
import BaseInput from "./BaseInput";

export default {
  components: {
    BaseInput
  },
  props: {
    value: {
      type: String,
      required: true
    },
    mtansend: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
</style>